export default __webpack_public_path__ + "static/media/make-it-zero.46f203b6.mp4";